import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@item item-id, Название предмета на русском}
export const ItemPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'item'} params={{id}} title={title} className={linkClass('item')}>
			{title}
		</Link>
	);
};
